import { type ReactNode } from "react";

import { Paragraph, Substyle } from "common/core/typography";
import { useId } from "util/html";

import Styles from "./numerical_chart.module.scss";

type NumericalChartProps = {
  number: number | string;
  detail: string;
  figureLabel?: string;
  subDetail?: ReactNode;
};

export function NumericalChart({ number, detail, figureLabel, subDetail }: NumericalChartProps) {
  const figureLabelId = useId();
  const figureDetailsId = useId();
  return (
    <div className={Styles.numericalChartsContainer}>
      <Paragraph className={Styles.figure}>
        <Substyle
          textStyle="hero"
          aria-describedby={figureLabel ? figureLabelId : figureDetailsId}
          aria-details={figureLabel ? figureDetailsId : undefined} // only add details if figureLabel is present
        >
          {number}
        </Substyle>
        {figureLabel ? (
          <Paragraph
            id={figureLabelId}
            textColor="subtle"
            size="small"
            className={Styles.figureLabel}
          >
            {figureLabel}
          </Paragraph>
        ) : null}
      </Paragraph>
      <Paragraph className={Styles.details}>
        <Substyle id={figureDetailsId} textStyle="allCapsLabelSmall">
          {detail}
        </Substyle>
        {subDetail}
      </Paragraph>
    </div>
  );
}
